// eslint-disable-next-line no-unused-vars
import {
  getDatasetList, getDatasetListCount
} from 'api/datasetSelector'

const datasetSelector = {
  state: {},
  mutations: {},
  actions: {
    getDatasetList ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getDatasetList(data).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    },
    getDatasetListCount ({commit, state}, data) {
      return new Promise((resolve, reject) => {
        getDatasetListCount(data).then((res) => {
          resolve(res.result)
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }
}

export default datasetSelector



// WEBPACK FOOTER //
// ./src/store/modules/datasetSelector.js